module.exports = __webpack_public_path__ + "static/media/ico-time-count.f54a1207.svg";